import { defaultApiState } from '../api.state';

export const faqState = {
  apiState: {
    getFaqs: defaultApiState,
    getFaq: defaultApiState,
    deleteFaq: defaultApiState,
    addFaq: defaultApiState,
    updateFaq: defaultApiState,
  },
  faqs: [],
  faq: undefined,
};
